import React from "react";
import { TableHead, TableHeader, TableRow } from "../../../../../components/ui/common/table";
import { cn } from "../../../../../lib/utils";
import { FIRST_RIGHT_ALIGNED_COLUMN, PROCESS_DATA_COLUMNS } from "../constants/processRecords.constants";

interface ProcessTableHeaderProps {
  /** When a row is being edited, columns widen to fit the inline inputs. */
  editing: boolean;
}

const ProcessTableHeader: React.FC<ProcessTableHeaderProps> = ({ editing }) => (
  <TableHeader className="!tw-bg-muted/70">
    <TableRow className="tw-bg-muted/70">
      <TableHead className="!tw-w-5 !tw-px-2" />
      {PROCESS_DATA_COLUMNS.map((label, idx) => (
        <TableHead
          key={label}
          className={cn(
            "tw-text-xs !tw-px-2",
            idx >= FIRST_RIGHT_ALIGNED_COLUMN && "tw-text-right",
            editing && (idx === 0 ? "!tw-min-w-[300px]" : "!tw-min-w-[250px]")
          )}
        >
          {label}
        </TableHead>
      ))}
      <TableHead className="tw-text-xs tw-text-right !tw-px-2">Actions</TableHead>
    </TableRow>
  </TableHeader>
);

export default ProcessTableHeader;
